export default __webpack_public_path__ + "static/media/art-pro-blk-1.e1d005b0.png";